module.exports = __webpack_public_path__ + "img/swine-promote.4dcfc0c1.png";